import React, { FC, useEffect, useRef, useState, useCallback } from 'react';

interface ScopeItem {
  text: string;
  value: string;
}

interface LeasingTeamSelectorProps {
  currentLeasingTeam: any;
  leasingTeams: any[];
  leasingTeamsBadgeCounts: any;
}

const LeasingTeamSelector: FC<LeasingTeamSelectorProps> = ({
  currentLeasingTeam,
  leasingTeams,
  leasingTeamsBadgeCounts
}) => {
  const [currentPage, setCurrentPage] = useState(true);
  const scopeRef = useRef<HTMLElement | null>(null);

  const applyCheckMark = useCallback(() => {
    const options = document.querySelectorAll('.o-option');
    options.forEach((element) => {
      const text = element.textContent?.split('(')[0].trim();
      const checkMark = element.querySelector('.o-option__check-mark');
      if (checkMark?.classList.contains('o-mark')) {
        checkMark.classList.remove('o-mark');
      }
      if (text === currentLeasingTeam.name && checkMark) {
        checkMark.classList.add('o-mark');
      }
    });
  }, [currentLeasingTeam.name]);

  useEffect(() => {
    const handleScopeChange = (e: Event) => {
      const customEvent = e as CustomEvent;
      const teamId = customEvent.detail.value;
      setCurrentPage(!currentPage);
      window.open('/dashboard?lt=' + teamId, '_blank');
    };

    const scopeElementRef = scopeRef.current;
    if (!scopeElementRef) return;
    if (scopeElementRef) {
      scopeRef.current = scopeElementRef;
      const formattedLeasingTeams: ScopeItem[] = leasingTeams.map((team) => {
        const badgeCount = leasingTeamsBadgeCounts?.[team.publicId] || 0;
        const displayBadgeCount = badgeCount > 0 ? `(${badgeCount})` : '';
        return {
          text: `${team.name} ${displayBadgeCount}`,
          value: team.publicId
        };
      });
      (scopeRef.current as any).items = formattedLeasingTeams;
      scopeElementRef.addEventListener('scopeChange', handleScopeChange);
      return () => {
        scopeElementRef.removeEventListener('scopeChange', handleScopeChange);
      };
    }
  }, [currentPage, leasingTeams, leasingTeamsBadgeCounts]);

  useEffect(() => {
    const observer = new MutationObserver(() => {
      applyCheckMark();
    });
    const scopeElementRef = scopeRef.current;
    if (scopeElementRef) {
      observer.observe(scopeElementRef, {
        childList: true,
        subtree: true
      });
    }
    return () => observer.disconnect();
  }, [applyCheckMark]);
  return (
    <omnibar-scope
      ref={scopeRef}
      slot="scope"
      product={currentLeasingTeam.name}
      selector
      searchable
    ></omnibar-scope>
  );
};
export default LeasingTeamSelector;
